import { ColumnsType } from "antd/es/table";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getRanking } from "../db";
import HomeButton from "./HomeButton";
import { Table } from "antd";
import { DocumentData } from "firebase/firestore";
import 배경이미지 from "../assets/home.png";
import Notice from "./Notice";

const Ranking = () => {
  const [rankerList, setRankerList] = useState<DocumentData[]>([]);
  const [isFetching, setIsFetching] = useState(false);

  const columns: ColumnsType<any> = [
    {
      title: "순위",
      render: (_, __, index) => `${index + 1}위`,
    },
    {
      title: "이름",
      dataIndex: "userName",
    },
    {
      title: "점수",
      dataIndex: "bestScore",
    },
  ];

  useEffect(() => {
    const asnycFunc = async () => {
      setIsFetching(true);
      const list = await getRanking();
      setRankerList(list);
      setIsFetching(false);
    };
    asnycFunc();
  }, []);

  return (
    <Container>
      <Notice positionStatic />
      <STable
        rowKey={(row) => row.uid}
        columns={columns}
        dataSource={rankerList}
        loading={isFetching}
        pagination={false}
      />
      <ButtonWrapper>
        <HomeButton />
      </ButtonWrapper>
    </Container>
  );
};

export default Ranking;

const Container = styled.div`
  margin: auto;

  max-width: 420px;
  height: 100vh;

  /* min-height: 650px; */
  /* background-color: pink; */

  position: relative;
  background-image: url(${배경이미지});

  padding: 20px;
`;

const STable = styled(Table)`
  margin: 10px 0;

  border-radius: 12px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;
